export const FAQ_DATA = [
	{
		title: 'How long will it take for the money to reach me?',
		description: `Transfers may take up to 1-2 business days to reach the recipient, subject to bank and public holidays in both the sender and recipient's countries.`
	},
	{
		title: 'Money’s not in your account yet?',
		description: `In some cases, the tracker may indicate that the transfer is complete. However, the funds may still be held by the recipient’s bank due to some reasons:
			<ul>
				<li>Additional security checks</li>
				<li>Limited processing schedules</li>
				<li>Closures related to public holidays</li>
			</ul>
			<p>If the transfer has not been received after three business days, it is recommended to reach out to your bank or sender for further assistance.</p>`
	},
	{
		title: 'How can I track and collect a cash pickup transfer?',
		description: `Once the transfer is completed, the sender will receive a security code via the MoneyMatch app or
    email with a reference number and pickup details. To collect the funds, the recipient must:
			<ol>
				<li>Visit the designated cash pickup location.</li>
				<li>Present a valid security code.</li>
				<li>Complete the verification process and receive the funds.</li>
			</ol>`
	},
	{
		title: 'Are there additional steps required for Alipay transfers to China (CNY)?',
		description: `Yes, Alipay transfers to China (CNY) may require additional steps. To ensure a smooth transfer process, please
    review the necessary requirements and instructions in our support article. Click
    <a href="https://support.moneymatch.co/hc/en-us/articles/360021830372-CNY-to-China">here</a> to read the full details.`
	},
	{
		title: 'Are there additional steps required for transfers to South Korea (KRW)?',
		description: `Yes, transfers to South Korea (KRW) may require additional steps.
    To ensure a smooth transfer process, please review the necessary requirements and instructions in our support article.
    Click <a href="https://support.moneymatch.co/hc/en-us/articles/360038954012-KRW-Transfers">here</a> to read the full details.`
	},
	{
		title: 'Will my transfer tracking link expire?',
		description: `Your transfer tracking link will be available for 30 days from the date of your transaction.
    After 30 days, the link will expire and will no longer be accessible.`
	}
];
